const RequiredIndicator = () => {
  return (
    <span aria-hidden className="text-red-500">
      *
    </span>
  );
};

export default RequiredIndicator;
